(function (angular) {

    'use strict';

    angular.module('harriMainApp').controller('LmsWelcomeModal', LmsWelcomeModal);

    LmsWelcomeModal.$inject = ['$scope'];

    function LmsWelcomeModal($scope) {
        this.dontShow = false;
        this.hideModal = function () {
            $scope.$hide();
        };

        this.goToLMS = function () {
            this.checkStatusFlag();
            this.hideModal();
        };

        this.videoClicked = function () {

        };

        this.checkStatusFlag = function () {

        };

    }
})(angular);
